import React from "react";
import { Field } from "@design-system/Field/Field";
import { TextArea } from "@design-system/TextArea/TextArea";
import { useNativeInvoiceFormContext } from "./NativeInvoiceFormContext";
import { resetCollapsedTextAreaScroll } from "./resetCollapsedTextAreaScroll";
import styles from "./SidePanel.module.scss";

// Memo and payment instructions fields for the Details step's "Footer"
// section (both render in the document's bottom block).
export const CustomizeSection: React.FC = () => {
    const { state, setState } = useNativeInvoiceFormContext();

    return (
        <div className={styles.unframedSection}>
            <Field label="Memo">
                <TextArea
                    size="xl"
                    className={styles.collapsibleTextarea}
                    maxLength={2000}
                    onBlur={resetCollapsedTextAreaScroll}
                    value={state.note}
                    onChange={(event) =>
                        setState((prev) => ({
                            ...prev,
                            note: event.target.value,
                        }))
                    }
                />
            </Field>
            <Field label="Payment instructions">
                <TextArea
                    size="xl"
                    className={styles.collapsibleTextarea}
                    maxLength={2000}
                    onBlur={resetCollapsedTextAreaScroll}
                    value={state.terms}
                    onChange={(event) =>
                        setState((prev) => ({
                            ...prev,
                            terms: event.target.value,
                        }))
                    }
                />
            </Field>
        </div>
    );
};
